document.addEventListener("DOMContentLoaded",function () {
   /* Copyright - Gaelta */
const newLink = document.createElement("a");
newLink.href =
  "https://www.gaelta.com/?utm_source=footer&utm_medium=link&utm_campaign=create_by_gaelta";
newLink.target = "_blank";
newLink.textContent = "Created by Gaelta";
//
const newSpan = document.createElement("span");
newSpan.id = "Gaelta";
//
const imageTag = document.createElement("a");
imageTag.href =
  "https://www.gaelta.com/?utm_source=footer&utm_medium=link&utm_campaign=create_by_gaelta";
imageTag.target = "_blank";
//
var svgImage = document.createElement("img");
svgImage.src =
  "https://gaelta.com/wp-content/uploads/2024/07/Gaelta-Logo-icon.svg";
svgImage.width = 25;
svgImage.height = 17;
svgImage.alt = "Gaelta";
imageTag.appendChild(svgImage);
//
newSpan.appendChild(imageTag);
newSpan.appendChild(newLink);
document
  .querySelector(".section-footer .order-last")
  .insertAdjacentElement("beforeend", newSpan); 
});